import Colors from 'components/tokens/Colors';
import { Container, Row, Col } from 'components/atoms/Grid';
import Text from 'components/atoms/Text';
import NewsletterForm from './NewsletterForm';
import styled from 'styled-components';
import { sbEditable } from '@storyblok/storyblok-editable';
import { IsMobile } from 'helpers/isMobile';

export default function Newsletter(props) {
    return (
        <StyledContainer fluid px="1.5 1" {...sbEditable(props)}>
            <Container px="0 10">
                <Row>
                    <Col size="12" mb="8 12" mt="8 12">
                        <Row>
                            <Col size="12 6" mb="4 0">
                                <NewsDescription>
                                    <Divider className="divider" />
                                    <Text heading4 className="title">
                                        {props?.text}
                                    </Text>
                                </NewsDescription>
                            </Col>
                            <Col size="12 5" pl="1 2">
                              <NewsletterForm />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </StyledContainer>
    );
}

const Divider = styled.div`
    width: 45%;
    height: 2px;
    background-color: ${Colors.black};
    margin-bottom: 40px;
    @media (max-width: 768px) {
        width: 30%;
    }
`;

const NewsDescription = styled.div`
    width: 100%;
    @media (min-width: 768px) {
        max-width: 370px;
    }

    &:hover {
        .divider {
            transition: background 300ms;
            background: ${Colors.white};
        }
        .title {
            transition: opacity 300ms;
            opacity: 0.7;
        }
    }
`;

const StyledContainer = styled(Container)`
    background: ${Colors.educationGreen};
`;
